import React, {useEffect, useState} from 'react';

import {postRequest} from "../routes/Routes";

import '../assets/css/Login.css';

import logo from "../assets/images/logo.svg";

function UserInvitation() {
    const [secret] = useState(decodeURI(window.location.href.split('/').at(-1)));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [message, setMessage] = useState(null);

    useEffect(() => {
        let values = {
            dto: {
                secret: secret,
            },
            endpoint: '/api/user-invitation/validate',
        };
        postRequest(values).then(response => {
            if (response.status !== 200) {
                setMessage(response.data ? response.data.message : "An error occurred!");
            }
        });
    }, []);

    const setPasswordFunction = (event) => {
        setLoading(true);
        event.preventDefault();
        if (event.target.password.value !== event.target.confirmPassword.value) {
            setError(values => ({...values, error: true, errorMessage: "Passwords mismatching!"}));
            setLoading(false);
            return;
        }
        let values = {
            password: event.target.password.value,
            secret: secret,
            endpoint: '/api/user-invitation/accept'
        };
        postRequest(values).then(response => {
            if (response.status === 200) {
                setError(values => ({...values, error: false, errorMessage: null}));
                window.location.href = '/';
            } else {
                setError(values => ({...values, error: true, errorMessage: "An error occurred!"}));
            }
            setLoading(false);
        });
    }

    return (
        <div className="main">
            <div className='sub-main'>
                <form onSubmit={setPasswordFunction}>
                    <div className='img'>
                        <img src={logo} alt="Logo"/>
                    </div>
                    {message ?
                        <div className="alert login-alert alert-danger" role="alert">
                            {message}
                        </div>
                        : <>
                            <div>
                                <p className='heading'>Set Password</p>
                                <p className='description'>Enter a password for your account</p>
                            </div>
                            <div className="login-input-container">
                                <div className="form-group">
                                    <label htmlFor="password">Password</label>
                                    <input type="password" className="form-control login-input" name="password"
                                           placeholder="Type a password" required/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirmPassword">Confirm Password</label>
                                    <input type="password" className="form-control login-input" name="confirmPassword"
                                           placeholder="Confirm your password" required/>
                                </div>
                            </div>
                            {error.error &&
                            <div className="alert login-alert alert-danger" role="alert">
                                {error.errorMessage}
                            </div>}
                            <div>
                                <button type="submit" className='black-button login-button' disabled={loading}>
                                    {loading ?
                                        <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                              aria-hidden="true"/>
                                        : null
                                    }
                                    Confirm
                                </button>
                            </div>
                        </>
                    }
                </form>
            </div>
        </div>
    );
}

export default UserInvitation;
